// CDV-021: render a `list` block.

type Item = string | { text: string; hint?: string }

interface Props { //@usedby:ComposedBody.tsx
  items: Item[]
  ordered?: boolean
}

export function ListBlockView({ items, ordered = false }: Props) {
  const Tag = ordered ? 'ol' : 'ul'
  return (
    <Tag
      className={[
        'pl-5 space-y-1 text-sm text-foreground',
        ordered ? 'list-decimal' : 'list-disc',
      ].join(' ')}
    >
      {items.map((it, i) => {
        const text = typeof it === 'string' ? it : it.text
        const hint = typeof it === 'string' ? undefined : it.hint
        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: items are positional
          <li key={i}>
            <span>{text}</span>
            {hint ? (
              <div className="text-xs text-foreground-muted mt-0.5">{hint}</div>
            ) : null}
          </li>
        )
      })}
    </Tag>
  )
}
